import React from "react";
import "./ImageSection.css";

const ImageSection: React.FC = () => (
  <div className="image-container">
    <img src="/images/home.png" alt="Home" className="image" />
  </div>
);

export default ImageSection;
